import { memo } from "react";

// UI
import { TableSearch } from "ui/components/Table/TableSearch";

import { FLEET_VEHICLE_TRANSFER_SEARCH_COLUMNS } from "./consts";
import { VehicleTransferSearchResultsProps } from "./types";

/**
 * Popis premještaja vozila. Endpoint vraća cijelu povijest odjednom, pa tablica
 * nema straničenje — najnoviji premještaj je prvi.
 */
const TransferSearchResults: React.FC<VehicleTransferSearchResultsProps> = (props) => {
  const { transfers, isLoading, onRowClick, onDeleteClick } = props;

  return (
    <TableSearch
      columns={FLEET_VEHICLE_TRANSFER_SEARCH_COLUMNS(onDeleteClick)}
      data={transfers}
      selectableRows={false}
      disablePagination={true}
      isLoading={isLoading}
      onRowClick={onRowClick}
    />
  );
};

export default memo(TransferSearchResults);
